/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AllocationType } from './AllocationType';
import {
    AllocationTypeFromJSON,
    AllocationTypeFromJSONTyped,
    AllocationTypeToJSON,
} from './AllocationType';

/**
 * 
 * @export
 * @interface OptimizerError
 */
export interface OptimizerError {
    /**
     * 
     * @type {string}
     * @memberof OptimizerError
     */
    errorId: string;
    /**
     * 
     * @type {number}
     * @memberof OptimizerError
     */
    optimizationId: number;
    /**
     * 
     * @type {string}
     * @memberof OptimizerError
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof OptimizerError
     */
    sId?: string;
    /**
     * 
     * @type {AllocationType}
     * @memberof OptimizerError
     */
    allocationType?: AllocationType;
    /**
     * 
     * @type {string}
     * @memberof OptimizerError
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof OptimizerError
     */
    createdAt: string;
}

/**
 * Check if a given object implements the OptimizerError interface.
 */
export function instanceOfOptimizerError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "errorId" in value;
    isInstance = isInstance && "optimizationId" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

export function OptimizerErrorFromJSON(json: any): OptimizerError {
    return OptimizerErrorFromJSONTyped(json, false);
}

export function OptimizerErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimizerError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errorId': json['error_id'],
        'optimizationId': json['optimization_id'],
        'pId': json['p_id'],
        'sId': !exists(json, 's_id') ? undefined : json['s_id'],
        'allocationType': !exists(json, 'allocation_type') ? undefined : AllocationTypeFromJSON(json['allocation_type']),
        'message': json['message'],
        'createdAt': json['created_at'],
    };
}

export function OptimizerErrorToJSON(value?: OptimizerError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error_id': value.errorId,
        'optimization_id': value.optimizationId,
        'p_id': value.pId,
        's_id': value.sId,
        'allocation_type': AllocationTypeToJSON(value.allocationType),
        'message': value.message,
        'created_at': value.createdAt,
    };
}

